import { GlobalContexts, useGlobals } from '@/hooks/use-globals';
import { TranslateResult }            from 'vue-i18n';

export default (path = '', arg?: string[]): TranslateResult => {
  const { i18n, store }: GlobalContexts = useGlobals();
  return i18n.t(`${store.state.i18n.GLOBAL_PATH}${path ? `.${path}` : ''}`, arg || [ '' ]);
};
